module.exports = __webpack_public_path__ + "static/media/card-empty-gift-large.028ba1bb.png";